import { ElementType, forwardRef } from 'react';
import { breakpoints, useMatchMedia } from '@frontend/responsiveness';
import { useThreadHeaderContext } from '@frontend/thread-header-context';
import { PolymorphicComponentPropWithoutRef } from '@frontend/design-system';

type HeaderProps<E extends ElementType = 'div'> = PolymorphicComponentPropWithoutRef<E, Record<string, unknown>>;

export const Header = forwardRef(
  <E extends ElementType = 'div'>({ as, children, ...rest }: HeaderProps<E>, ref: React.Ref<any>) => {
    const { variant } = useThreadHeaderContext();
    const Component = as || 'div';
    const isSmallMode = useMatchMedia({ maxWidth: breakpoints.xsmall.max });

    return (
      <Component
        css={{
          display: 'flex',
          alignItems: variant === 'small' ? 'start' : 'center',
          padding: isSmallMode
            ? 'var(--fabric-space-padding-xs) var(--fabric-space-padding-md) var(--fabric-space-padding-xs) var(--fabric-space-padding-md)'
            : 'var(--fabric-space-padding-sm) var(--fabric-space-padding-md) var(--fabric-space-padding-xs) var(--fabric-space-padding-md)',
          columnGap: 'var(--fabric-space-gap-xs)',
          position: 'relative',
          width: '100%',
          justifyContent: 'space-between',
        }}
        {...rest}
        ref={ref}
      >
        {children}
      </Component>
    );
  }
);
Header.displayName = 'ThreadHeader.Header';
